import { createFileRoute } from '@tanstack/react-router';
import { PromisesPage } from '@/domains/collections';

// Ruta estática: gana sobre la dinámica hermana `$section`, que sigue cubriendo el resto del portal.
export const Route = createFileRoute('/_backoffice/collections/promises')({
    component: PromisesPage,
});
